<template>
  <div class="home-v2">
    <GlobalLoading v-if="$store.state.globalLoading" />
    <div class="masterdata-container">
      <div class="masterdata-dialog">
        <div class="masterdata-content">
          <div class="masterdata-body">
            <!-- <div class="modal-button-close">
                  <i class="far fa-times-circle"></i>
                </div> -->

            <!-- Konten Here -->
            <div class="home-v2">
              <div class="masterdata-v2">
                <Top />
                <!-- <ButtonTop :content="currentContent" /> -->
                <div v-if="currentTab === 'legal_doc'" class="masterdata-v2-top">
                  <Sidebar :currentTab="currentTab" />
                  <!-- isi data tabel -->
                  <ListTableKBLI v-if="currentContent === 'kbli'" :isEdit="isEdit" />
                  <ListTableDKBLI v-else-if="currentContent === 'dkbli'" :isEdit="isEdit" />
                  <ListTableIUJP v-else-if="currentContent === 'iujp'" :isEdit="isEdit" />
                  <ListTableSBUJK v-else-if="currentContent === 'sbujk'" :isEdit="isEdit" />
                  <ListTableIUJPTL v-else-if="currentContent === 'iujptl'" :isEdit="isEdit" />
                  <ListTableINUBBM v-else-if="currentContent === 'inu_bbm'" :isEdit="isEdit" />
                  <ListTableSiupal v-else-if="currentContent === 'siupal'" :isEdit="isEdit" />
                  <ListTableNegara v-else-if="currentContent === 'negara'" :isEdit="isEdit" />
                  <ListTableProvinsi v-else-if="currentContent === 'provinsi'" :isEdit="isEdit" />
                  <ListTableKota v-else-if="currentContent === 'kota'" :isEdit="isEdit" />
                  <ListTableKecamatan v-else-if="currentContent === 'kecamatan'" :isEdit="isEdit" />
                  <ListTableKelurahan v-else-if="currentContent === 'kelurahan'" :isEdit="isEdit" />
                </div>
                <div v-else-if="currentTab === 'tiket_vendor'" class="masterdata-v2-top">
                  <Sidebar :currentTab="currentTab" />
                  <!-- isi data tabel -->
                  <ListKategori v-if="currentContent === 'kategori'" :isEdit="isEdit" />
                  <ListTujuanPendaftaran v-else-if="currentContent === 'tujuan_pendaftaran'" :isEdit="isEdit" />
                </div>
                <div v-else-if="currentTab === 'sap'" class="masterdata-v2-top">
                  <Sidebar :currentTab="currentTab" />
                  <!-- isi data tabel -->
                  <ListBisnisUnit v-if="currentContent === 'bisnis_unit'" :isEdit="isEdit" />
                  <ListTipeBisnisUnit v-if="bisnisUnitList.includes(currentContent)" :isEdit="isEdit"
                    :content="currentContent" />
                </div>
                <div v-else-if="currentTab === 'k3l'" class="masterdata-v2-top">
                  <Sidebar :currentTab="currentTab" />
                  <!-- isi data tabel -->
                  <ListNonInti v-if="currentContent === 'non_inti'" :isEdit="isEdit" />
                  <ListGoldenRules v-else-if="currentContent === 'golden_rules'" :isEdit="isEdit" />
                  <ListKBUB v-else-if="currentContent === 'kbub'" :isEdit="isEdit" />
                </div>
                <div v-else-if="currentTab === 'kplh'" class="masterdata-v2-top">
                  <Sidebar :currentTab="currentTab" />
                  <!-- isi data tabel -->
                  <ListKBUG v-if="currentContent === 'kbug'" :isEdit="isEdit" />
                  <ListSignatureCompany v-if="currentContent === 'signature_company'" :isEdit="isEdit" />
                </div>

                <div class="masterdata-v2-bottom">
                  <Bottom :isEdit="isEdit" :content="currentContent" @editButton="editButton"
                    :currentTab="currentTab" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading'),

    Sidebar: () => import('@/components/masterdata/database/Sidebar'),
    Top: () => import('@/components/masterdata/database/Top'),
    Bottom: () => import('@/components/masterdata/database/Bottom'),

    // Tab Legal Doc
    ListTableKBLI: () => import('./Data/LegalDoc/KBLI'),
    ListTableDKBLI: () => import('./Data/LegalDoc/DKBLI'),
    ListTableIUJP: () => import('./Data/LegalDoc/IUJP'),
    ListTableSBUJK: () => import('./Data/LegalDoc/SBUJK'),
    ListTableIUJPTL: () => import('./Data/LegalDoc/IUJPTL'),
    ListTableINUBBM: () => import('./Data/LegalDoc/INUBBM'),
    ListTableSiupal: () => import('./Data/LegalDoc/SIUPAL'),
    ListTableNegara: () => import('./Data/LegalDoc/Negara'),
    ListTableProvinsi: () => import('./Data/LegalDoc/Provinsi'),
    ListTableKota: () => import('./Data/LegalDoc/Kota'),
    ListTableKecamatan: () => import('./Data/LegalDoc/Kecamatan'),
    ListTableKelurahan: () => import('./Data/LegalDoc/Kelurahan'),

    // Tab Vendor Baru
    ListKategori: () => import('./Data/TiketVendor/Kategori'),
    ListTujuanPendaftaran: () => import('./Data/TiketVendor/TujuanPendaftaran'),

    // Tab SAP
    ListBisnisUnit: () => import('./Data/SAP/BisnisUnit'),
    ListTipeBisnisUnit: () => import('./Data/SAP/BisnisUnitName'),

    // Tab K3L
    ListNonInti: () => import('./Data/K3L/NonInti'),
    ListGoldenRules: () => import('./Data/K3L/GoldenRules'),
    ListKBUB: () => import('./Data/K3L/KBUB'),

    // Tab KPLH
    ListKBUG: () => import('./Data/KPLH/KBUG'),
    ListSignatureCompany: () => import('./Data/KPLH/SignatureCompany'),

    ButtonTop: () => import('@/components/masterdata/database/ButtonTop'),
    Loading: () => import('@/components/V2/GlobalLoading'),
  },
  data() {
    return {
      user_id: null,
      isEdit: false,
      bisnis_unit_name: ['BCE', 'GEMS', 'BKES', 'SUN'],
      tableData: [],
    }
  },
  created() {
    this.$store.dispatch('mdDatabaseStore/onPageLoad', {
      name: 'currentContent',
      value: 'kbli',
    })
  },
  computed: {
    bisnisUnitList() {
      const result = this.$store.state.mdDatabaseStore.bisnisUnitData
      const arr = result.map(list => {
        return list.name
      })
      return arr
    },
    currentTab() {
      const tab = this.$get(
        this.$store,
        'state.mdDatabaseStore.selectedTab',
        'legal-doc'
      )

      return tab
    },
    currentContent() {
      const contentTab = this.$get(
        this.$store,
        'state.mdDatabaseStore.currentContent',
        'kbli'
      )

      return contentTab
    },
  },

  methods: {
    editButton() {
      this.isEdit = !this.isEdit
    },
  },
}
</script>
